import { z } from "zod";
import { dateStringSchema } from "./common.js";
export const contractLabelSchema = z.object({
    id: z.number(),
    networkId: z.string(),
    address: z.string(),
    label: z.string(),
    contractType: z.string().nullable(),
    createdAt: dateStringSchema,
});
export const createLabelBodySchema = z.object({
    address: z.string(),
    label: z.string(),
    contractType: z.string().optional(),
});
//# sourceMappingURL=labels.js.map